export default "__VITE_ASSET__BhLxRpN6__"